import 'react-hot-loader/patch';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import 'style/fonts.css';
import App from './app';
import './i18n';

ReactDOM.render(<App />, document.getElementById('root'));
